import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import {
  Container,
  Row,
  Col,
  Input,
  Button
} from '@leroy-merlin-br/backyard-react-ui'

import * as S from './styled'

function Form ({ onSubmit, isRequest }) {
  const {
    handleSubmit,
    register,
    errors,
    reset,
    formState: { isSubmitSuccessful }
  } = useForm({ mode: 'onBlur' })

  useEffect(() => {
    if (isSubmitSuccessful) {
      reset()
    }
  }, [isSubmitSuccessful, reset])

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <S.Wrapper>
        <Container>
          <Row align="center">
            <Col
              size={{
                kilo: 2,
                giga: 4,
                tera: 3
              }}
            >
              <S.Heading size="giga" noMargin>
                Fique por dentro das <span>novidades</span> e{' '}
                <span>promoções</span>
              </S.Heading>
            </Col>
            <Col
              size={{
                kilo: 2,
                giga: 4,
                tera: 9
              }}
            >
              <S.Inline spacing="mega" align="bottom" noWrap>
                <Input
                  name="email"
                  label="E-mail"
                  placeholder="seuemail@email.com"
                  ref={register({
                    required: 'Insira seu e-mail',
                    validate: value =>
                      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i.test(
                        value
                      ) || 'E-mail inválido'
                  })}
                  isInvalid={Boolean(errors?.email?.message)}
                />
                <Button type="submit" isLoading={isRequest}>
                  Cadastrar
                </Button>
              </S.Inline>
            </Col>
          </Row>
        </Container>
      </S.Wrapper>

      <S.Text size="kilo" italic noMargin>
        Ao se cadastrar você concorda em receber e-mails promocionais e
        novidades. Saiba mais na nossa{' '}
        <a href="/institucional/politica-de-privacidade">
          Politica de Privacidade
        </a>
      </S.Text>
    </form>
  )
}

export default Form
